import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconFormatQuoteStyle0 = gravityIconIndividualCss;

const GravityIconFormatQuote = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'ef7c26a0ef3f573275a6333766b395626c757a3f', color: this.color, size: this.size }, h("svg", { key: '9ea9c3c0acda2a69eb823c751fc71ebe7f6a34e5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'eaec8bb67f6b00eef33a3b98735ab76889179c48', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.925 7.425A3.5 3.5 0 0 1 15.5 4a3.5 3.5 0 0 1 3.26 4.77l-3.61 9a.52.52 0 0 1-.44.25h-1.35a.5.5 0 0 1-.43-.75L15.35 11a3.5 3.5 0 0 1-3.425-3.575Zm-9 0A3.5 3.5 0 0 1 6.5 4 3.5 3.5 0 0 1 10 7.5c0 .428-.08.853-.24 1.25l-3.61 9a.52.52 0 0 1-.44.25H4.36a.5.5 0 0 1-.43-.75L6.35 11a3.5 3.5 0 0 1-3.425-3.575Z", fill: "currentColor" }))));
    }
};
GravityIconFormatQuote.style = GravityIconFormatQuoteStyle0;

export { GravityIconFormatQuote as gravity_icon_format_quote };

//# sourceMappingURL=gravity-icon-format-quote.entry.js.map